import cloneDeep from 'lodash/cloneDeep';

import { stepConfigs } from '@bv/components/workflow/partials/steps';

/**
 * Get cloned form fields for a node type
 */
export function getClonedFieldsForNodeType(nodeType: string): any[] | null {
  const stepConfig = stepConfigs[nodeType];
  if (stepConfig?.formFields) {
    return cloneDeep(stepConfig.formFields);
  }
  return null;
}
